var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#nexArrow)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.26651 7.26308C8.91116 7.61235 8.91116 8.17655 9.26651 8.52581L12.8018 12.0006L9.26651 15.4753C8.91116 15.8246 8.91116 16.3888 9.26651 16.738C9.62187 17.0873 10.1959 17.0873 10.5513 16.738L14.7335 12.6275C15.0888 12.2782 15.0888 11.714 14.7335 11.3647L10.5513 7.25412C10.205 6.91381 9.62187 6.91381 9.26651 7.26308Z",
    fill: props.color
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "nexArrow"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.b6c9dd380c71162fbeab4bfb8581f6fe.svg";
export { ForwardRef as ReactComponent };